
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexILYwNDjxxH9ldRo90owotpxYyUalFRau6HSOLSYizHIMeta } from "C:/Duhan Projects/teknopark-site/pages/about/index.vue?macro=true";
import { default as index46xbYqeyVcP4jM0bgFbTMJI5dpVYFCsjEZxz2SU5L8cMeta } from "C:/Duhan Projects/teknopark-site/pages/about/partners/index.vue?macro=true";
import { default as _91slug_937XLrBCs9ZB1PJy34XS4TfP5Fzm_4BC9Zy1VdlrXvxL4Meta } from "C:/Duhan Projects/teknopark-site/pages/companies/[slug].vue?macro=true";
import { default as alluZ_wHEKPLLCD7rlfFrswT7vnacthITYWo0GzhpC89joMeta } from "C:/Duhan Projects/teknopark-site/pages/companies/all.vue?macro=true";
import { default as indexsXXGUsz9DcRr7i6VX6iUY8kcZch4yrqLJxZhoJ6Rr_oMeta } from "C:/Duhan Projects/teknopark-site/pages/companies/index.vue?macro=true";
import { default as _91slug_93dXFWCf8xh5zQ5_QwGli9gG1wUkgZFjX2vrB4WwME7w4Meta } from "C:/Duhan Projects/teknopark-site/pages/companies/sectors/[slug].vue?macro=true";
import { default as sectorsNeMnVf2_45B5fRecjbakimhtMnmVhHI9n7AuJzN9ncKAIMeta } from "C:/Duhan Projects/teknopark-site/pages/companies/sectors.vue?macro=true";
import { default as success_45storiesBcjH3t49QZWOGG1PiAfTctf29BDPnhuxk2OJePAmLV8Meta } from "C:/Duhan Projects/teknopark-site/pages/companies/success-stories.vue?macro=true";
import { default as contact7WjenbSpanGJiz0AGQRzK6omnhIXf3fSkqLffO73VBUMeta } from "C:/Duhan Projects/teknopark-site/pages/contact.vue?macro=true";
import { default as cv_45poolMgGXqKEsx_KW2RMdcbWk61txQIJSSPw869bPGAgAhcUMeta } from "C:/Duhan Projects/teknopark-site/pages/cv-pool.vue?macro=true";
import { default as _91slug_93688Akn6PnihFmRc0q7uTjOkSSyjKKQ5GS9aDqi4XPhIMeta } from "C:/Duhan Projects/teknopark-site/pages/events/[slug].vue?macro=true";
import { default as indexbZ_45wNiRARW5ye6LHAw40mzh__Azoh9q9Rduu0M_456CG0Meta } from "C:/Duhan Projects/teknopark-site/pages/events/index.vue?macro=true";
import { default as faqsfh1TznuOByBJo7iOs_45wXLnwpXBfGfLxD2ARwQEtJJEMeta } from "C:/Duhan Projects/teknopark-site/pages/faq.vue?macro=true";
import { default as indexhqZrYIjbv_rRL4UDEVx3Tl5pb2_64mfFTbqBVaYWpxYMeta } from "C:/Duhan Projects/teknopark-site/pages/index.vue?macro=true";
import { default as maintenanceW9KHXx3X0dlRg4bUsdN954w5Vehi_RH68jw0VOgAwTsMeta } from "C:/Duhan Projects/teknopark-site/pages/maintenance.vue?macro=true";
import { default as _91slug_93OcdfM9dOgBOEZYLMCwC7HVjse0XlmsK3Q9PHCm2jVtwMeta } from "C:/Duhan Projects/teknopark-site/pages/news/[slug].vue?macro=true";
import { default as indexlq6nBi9kLG9YpYK8JRRVwK5mxTgJJSuCa4gj_Luw1fIMeta } from "C:/Duhan Projects/teknopark-site/pages/news/index.vue?macro=true";
import { default as _91_46_46_46slug_93H_459svqZh4OTBzZ2HtqE_45UBgGa6iXFG7AgBPuxnLTBm0Meta } from "C:/Duhan Projects/teknopark-site/pages/pages/[...slug].vue?macro=true";
import { default as conference_45roomCx_45WGYbykIHFGv3aXx_nZCcpWOx_45Lssh7TvpAoKQjdYMeta } from "C:/Duhan Projects/teknopark-site/pages/services/conference-room.vue?macro=true";
import { default as indexZt8u6xDH2v_451ZK6MwC9otH_eGHqcEKxNcqilbOnnibAMeta } from "C:/Duhan Projects/teknopark-site/pages/services/index.vue?macro=true";
import { default as rental_45feesrHBkvnr1brpmSbwQ_nWyGtpoFnpBOkIahqBoczr96jQMeta } from "C:/Duhan Projects/teknopark-site/pages/services/rental-fees.vue?macro=true";
export default [
  {
    name: "about___tr",
    path: "/about",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/about/index.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/about/index.vue")
  },
  {
    name: "about-partners___tr",
    path: "/about/partners",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/about/partners/index.vue")
  },
  {
    name: "about-partners___en",
    path: "/en/about/partners",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/about/partners/index.vue")
  },
  {
    name: "companies-slug___tr",
    path: "/firmalar/:slug()",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/companies/[slug].vue")
  },
  {
    name: "companies-slug___en",
    path: "/en/companies/:slug()",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/companies/[slug].vue")
  },
  {
    name: "companies-all___tr",
    path: "/companies/all",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/companies/all.vue")
  },
  {
    name: "companies-all___en",
    path: "/en/companies/all",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/companies/all.vue")
  },
  {
    name: "companies___tr",
    path: "/companies",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/companies/index.vue")
  },
  {
    name: "companies___en",
    path: "/en/companies",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/companies/index.vue")
  },
  {
    name: "companies-sectors___tr",
    path: "/firmalar/sektorler",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/companies/sectors.vue"),
    children: [
  {
    name: "companies-sectors-slug___tr",
    path: ":slug()",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/companies/sectors/[slug].vue")
  }
]
  },
  {
    name: "companies-sectors___en",
    path: "/en/companies/sectors",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/companies/sectors.vue"),
    children: [
  {
    name: "companies-sectors-slug___en",
    path: ":slug()",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/companies/sectors/[slug].vue")
  }
]
  },
  {
    name: "companies-success-stories___tr",
    path: "/companies/success-stories",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/companies/success-stories.vue")
  },
  {
    name: "companies-success-stories___en",
    path: "/en/companies/success-stories",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/companies/success-stories.vue")
  },
  {
    name: "contact___tr",
    path: "/contact",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/contact.vue")
  },
  {
    name: "cv-pool___tr",
    path: "/cv-pool",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/cv-pool.vue")
  },
  {
    name: "cv-pool___en",
    path: "/en/cv-pool",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/cv-pool.vue")
  },
  {
    name: "events-slug___tr",
    path: "/etkinlikler/:slug()",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/events/[slug].vue")
  },
  {
    name: "events-slug___en",
    path: "/en/events/:slug()",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/events/[slug].vue")
  },
  {
    name: "events___tr",
    path: "/etkinlikler",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/events/index.vue")
  },
  {
    name: "events___en",
    path: "/en/events",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/events/index.vue")
  },
  {
    name: "faq___tr",
    path: "/faq",
    meta: faqsfh1TznuOByBJo7iOs_45wXLnwpXBfGfLxD2ARwQEtJJEMeta || {},
    component: () => import("C:/Duhan Projects/teknopark-site/pages/faq.vue")
  },
  {
    name: "faq___en",
    path: "/en/faq",
    meta: faqsfh1TznuOByBJo7iOs_45wXLnwpXBfGfLxD2ARwQEtJJEMeta || {},
    component: () => import("C:/Duhan Projects/teknopark-site/pages/faq.vue")
  },
  {
    name: "index___tr",
    path: "/",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/index.vue")
  },
  {
    name: "maintenance___tr",
    path: "/maintenance",
    meta: maintenanceW9KHXx3X0dlRg4bUsdN954w5Vehi_RH68jw0VOgAwTsMeta || {},
    component: () => import("C:/Duhan Projects/teknopark-site/pages/maintenance.vue")
  },
  {
    name: "maintenance___en",
    path: "/en/maintenance",
    meta: maintenanceW9KHXx3X0dlRg4bUsdN954w5Vehi_RH68jw0VOgAwTsMeta || {},
    component: () => import("C:/Duhan Projects/teknopark-site/pages/maintenance.vue")
  },
  {
    name: "news-slug___tr",
    path: "/haberler/:slug()",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/news/[slug].vue")
  },
  {
    name: "news-slug___en",
    path: "/en/news/:slug()",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/news/[slug].vue")
  },
  {
    name: "news___tr",
    path: "/haberler",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/news/index.vue")
  },
  {
    name: "news___en",
    path: "/en/news",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/news/index.vue")
  },
  {
    name: "pages-slug___tr",
    path: "/sayfa/:slug(.*)*",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/pages/[...slug].vue")
  },
  {
    name: "pages-slug___en",
    path: "/en/page/:slug(.*)*",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/pages/[...slug].vue")
  },
  {
    name: "services-conference-room___tr",
    path: "/hizmetler/konferans-salonu",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/services/conference-room.vue")
  },
  {
    name: "services-conference-room___en",
    path: "/en/services/conference-room",
    component: () => import("C:/Duhan Projects/teknopark-site/pages/services/conference-room.vue")
  },
  {
    name: "services___tr",
    path: "/services",
    meta: indexZt8u6xDH2v_451ZK6MwC9otH_eGHqcEKxNcqilbOnnibAMeta || {},
    component: () => import("C:/Duhan Projects/teknopark-site/pages/services/index.vue")
  },
  {
    name: "services___en",
    path: "/en/services",
    meta: indexZt8u6xDH2v_451ZK6MwC9otH_eGHqcEKxNcqilbOnnibAMeta || {},
    component: () => import("C:/Duhan Projects/teknopark-site/pages/services/index.vue")
  },
  {
    name: "services-rental-fees___tr",
    path: "/hizmetler/kira-ucretleri",
    meta: rental_45feesrHBkvnr1brpmSbwQ_nWyGtpoFnpBOkIahqBoczr96jQMeta || {},
    component: () => import("C:/Duhan Projects/teknopark-site/pages/services/rental-fees.vue")
  },
  {
    name: "services-rental-fees___en",
    path: "/en/services/rental-fees",
    meta: rental_45feesrHBkvnr1brpmSbwQ_nWyGtpoFnpBOkIahqBoczr96jQMeta || {},
    component: () => import("C:/Duhan Projects/teknopark-site/pages/services/rental-fees.vue")
  }
]